<div class="utilities-cards-wrapper">
  <ng-container *ngIf="utilitiesCards.title" [ngSwitch]="headlineSize">
    <h4 *ngSwitchCase="Headlines.H4">{{ utilitiesCards.title }}</h4>
    <h3 *ngSwitchCase="Headlines.H3">{{ utilitiesCards.title }}</h3>
    <h2 *ngSwitchCase="Headlines.H2">{{ utilitiesCards.title }}</h2>
    <h1 *ngSwitchCase="Headlines.H1">{{ utilitiesCards.title }}</h1>
  </ng-container>
  <div
    class="utilities-cards"
    *ngIf="utilitiesCards && utilitiesCards.items"
    [class]="columns"
  >
    <ng-container *ngFor="let item of utilitiesCards.items">
      <ng-container
        *ngIf="!utilitiesCards.title && item.itemsTitle"
        [ngSwitch]="headlineSize"
      >
        <h4 *ngSwitchCase="Headlines.H4">{{ item.itemsTitle }}</h4>
        <h3 *ngSwitchCase="Headlines.H3">{{ item.itemsTitle }}</h3>
        <h2 *ngSwitchCase="Headlines.H2">{{ item.itemsTitle }}</h2>
        <h1 *ngSwitchCase="Headlines.H1">{{ item.itemsTitle }}</h1>
      </ng-container>
      <div
        class="utilities-cards-item"
        [style.backgroundColor]="
          backgroundColor === 'grey'
            ? Colors.NEUTRAL_LIGHTEST
            : Colors.NEUTRAL_LIGHTER
        "
      >
        <a
          class="utility-link"
          [href]="item.url"
          [target]="item.target"
          [title]="item.title"
          (click)="
            item.url && item.target !== '_blank'
              ? navigateToInternalPage($event, item.url)
              : null
          "
        >
          <hdi-icon
            *ngIf="item.leftIcon"
            [size]="Sizes.XMEDIUM"
            [iconName]="item.leftIcon"
            [color]="item.leftIconColor ?? Colors.NEUTRAL_DARK"
          ></hdi-icon>
          <p [title]="item.title" [innerHTML]="item.label"></p>
          <hdi-badge
            *ngIf="item.badgeLabel"
            [type]="BadgeType.CAPSULE"
            [label]="item.badgeLabel | capitalize"
            [size]="Sizes.XSMALL"
          ></hdi-badge>
        </a>
        <span
          *ngIf="item.rightIcon"
          (click)="
            item.modal
              ? openModal(item.modal)
              : item.tooltip
                ? openTooltip(item.tooltip, $event)
                : null
          "
        >
          <hdi-tooltip
            *ngIf="item.tooltip && item.tooltip.id === tooltip.id"
            [id]="'tooltip' + item.tooltip.id"
            [tooltip]="item.tooltip"
            (closeTooltipEvent)="closeTooltip()"
          ></hdi-tooltip>
          <hdi-icon
            [iconName]="item.rightIcon"
            [size]="Sizes.XMEDIUM"
            [color]="Colors.NEUTRAL_MEDIUM"
          ></hdi-icon>
        </span>
      </div>
    </ng-container>
  </div>
</div>

<hdi-modal [showModal]="showModal" (closeModalTrigger)="showModal = $event">
  <div class="header-content">
    <h5 class="header-content">{{ modal.title }}</h5>
  </div>
  <p class="modal-content" [innerHTML]="modal.description"></p>
</hdi-modal>
